import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';
import { APP_CONFIG, AppConfig } from '@cco-apps/cco-frontend';
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';
import * as markerClusterer from '@googlemaps/markerclusterer';

@Injectable()
export class GoogleMapsApiLoader {
  private config = inject<AppConfig>(APP_CONFIG);

  private loadStarted = false;
  private loadCompletedSource$ = new BehaviorSubject<boolean>(false);
  private loadComplete$ = this.loadCompletedSource$.pipe(filter(loaded => !!loaded));

  load$(): Observable<boolean> {
    if (this.loadStarted) {
      return this.loadComplete$;
    }

    this.loadStarted = true;

    setOptions({
      key: this.config.googleMapsApiKey,
    });

    Promise.all([
      importLibrary('core'),
      importLibrary('maps'),
      importLibrary('places'),
      importLibrary('geometry'),
      importLibrary('marker'),
    ]).then(() => {
      globalThis.markerClusterer = markerClusterer;

      this.loadCompletedSource$.next(true);
    }).catch((err) => {
      Sentry.captureException(err, {
        fingerprint: [
          '{{ default }}',
          'google-maps-load-error',
        ],
      });
    });

    return this.loadComplete$;
  }
}
